/*
 * Name: Image List
 * Desc:
 *
 */
import React, { useEffect, useRef } from "react"
import MasonryInfiniteScroller from "react-masonry-infinite"
import ImageCard from "../ImageCard/ImageCard"
import * as styles from "./ImageList.module.scss"
import useMediaQuery from "@lib/useMediaQuery"
import useWindowSize from "@lib/useWindowSize"
import FetchSpinner from "@components/global/FetchSpinner/FetchSpinner"
import FetchSpinnerCard from "@components/global/FetchSpinner/FetchSpinnerCard"
import Button from "@components/objects/Button/Button"

const ImageList = (props) => {
  // Resize control
  const isMobile = useMediaQuery(1100)

  const emptyState = props.empty ? (
    <div className={`${styles.empty}`}>
      <div className={styles.image}>
        <img src={isMobile ? props.empty.backgroundImage.mobile : props.empty.backgroundImage.desktop} />
        <div className={styles.overlay}>
          <div className={styles.text}>
            {props.empty.title && <h2>{props.empty.title}</h2>}
            <p>{props.empty.text}</p>

            <Button text={props.empty.btnLabel} onClick={props.clearAllFilters} />
          </div>
        </div>
      </div>

      {props.empty.extra && (
        <div className={styles.extra}>
          <a target="_blank" href={props.empty.extra.link} rel="noreferrer">
            <p>{props.empty.extra.text}</p>
          </a>
        </div>
      )}
    </div>
  ) : null

  // repack masonry on resize
  const masonryScroller = useRef()
  const rePackMasonry = () => {
    if (!masonryScroller.current) return
    masonryScroller.current.forcePack()
    setTimeout(() => {
      masonryScroller.current.forcePack()
    }, 400)
  }

  useEffect(() => {
    window.addEventListener("resize", rePackMasonry)
    return () => {
      window.removeEventListener("resize", rePackMasonry)
    }
  }, [])

  // Determin height for masonry load
  // height = calc(25vw - 30px) * ratio from dato
  const { width } = useWindowSize()
  const getWidth = () => {
    if (width < 768) {
      return width / 2 - 15
    }
    if (width < 1100) {
      return width / 3 - 25
    }
    return width / 4 - 30
  }

  const imagesWidth = getWidth()

  const images =
    props.images && props.images.length
      ? props.images.map((image) => (
          <ImageCard
            key={image.id}
            image={image}
            handleChange={props.handleChange}
            width={imagesWidth}
            selected={!!props.imagesSelected[image.id]}
            isMobile={isMobile}
            imigixParams={props.imigixParams}
          />
        ))
      : null

  const imagesSection =
    images && images.length ? (
      <section className={styles.ImageList}>
        <MasonryInfiniteScroller
          ref={masonryScroller}
          pack
          position={false}
          useWindow
          pageStart={0}
          loadMore={props.loadFunc}
          hasMore={props.hasMore}
          initialLoad={false}
          sizes={[
            { columns: 2, gutter: 5 },
            { mq: "768px", columns: 3, gutter: 10 },
            { mq: "1100px", columns: 4, gutter: 20 },
          ]}
          loader={props.hasMore && <FetchSpinner />}
        >
          {images}
        </MasonryInfiniteScroller>
      </section>
    ) : null

  //   while suppliers haven't been fetched show spinner if results return with 0 show emptystate otherwise load supplier section
  if (props.images) {
    if (props.images.length === 0) {
      return emptyState
    }
    if (props.images.length) {
      return imagesSection
    }
    return <FetchSpinnerCard view="masonry" type="image" />
  }
  return <FetchSpinnerCard view="masonry" type="image" />
}

export default ImageList
